export { HeroText } from './hero-text-props';
